module.exports = __webpack_public_path__ + "static/media/LVFrame10.af49c959.png";